<template>
    <swiper-pagination v-bind="$attrs" class="swiper-pagination--filled-outlined"><slot /></swiper-pagination>
</template>

<script>
import SwiperPagination from "@/components/publish/styles/swipers/swiper-pagination.vue";

export default {
    props: {},
    components: { SwiperPagination },
    data() {
        return {};
    },
    mounted() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.swiper-pagination--filled-outlined {
    ::v-deep {
        .swiper-pagination {
            &-bullet {
                opacity: 1;
                background-color: transparent;
                &-active {
                    background-color: currentColor;
                }
            }
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
}
@media (min-width: 1024px) {
}
@media (min-width: 1200px) {
}
</style>
